import React, { useLayoutEffect } from "react";
import HocPopup from "../../../../hoc/hocPopup";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Paper,
  TextField,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import EventIcon from "@mui/icons-material/Event";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { TYPE, capitalizeFirstLetter } from "../../../../utils/Utils";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { PersonAddAlt1, Refresh } from "@mui/icons-material";
import EmailBillingDialog from "./dialog/dialogBody/EmailBilling.dialog";
import moment from "moment";
import BreadcrumbsComponent from "../../../base/Breadcrumbs.component";
import { utils, write } from "xlsx";
import {
  DEALERSHIP_BILLING,
  GET_DEALERSHIPS,
} from "../../../../graphql/query/query";
import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useAppContext } from "../../../../context/App.context";
import { InputValidation } from "../../../../utils/InputValidationRegex";
import { getStateCode, states } from "../../../../utils/StatesList.utils";
import DealershipStyles from "./Dealership.styles";
const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
console.log("userTimezone", userTimezone);
const INITIAL_FILTER = {
  dealershipName: "",
  email: "",
  monthYear: moment(
    new Date().toLocaleString("en-US", {
      timeZone: userTimezone,
    })
  ).format("YYYY-MM-DD"),
  dealershipCity: "",
};
const breadcrumb = {
  title: "Dealership",
  links: [{ path: "/", name: "" }],
};
const DealershipComponent = ({ dialog }) => {
  const app = useAppContext();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(200);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [dealerships, setDealerships] = useState([]);
  const [filterData, setFilterData] = useState(INITIAL_FILTER);
  const [sample, setSample] = useState(null);

  const { loading, data, refetch } = useQuery(GET_DEALERSHIPS, {
    variables: {
      filterInput: {
        city: filterData.dealershipCity,
        dealership_name: filterData.dealershipName,
        email: filterData.email,
        date: filterData.monthYear,
        rowsPerPage: rowsPerPage,
        pageCount: page,
      },
    },
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
  });

  useLayoutEffect(() => {
    if (data?.getDealerships?.dealerships) {
      setDealerships([...data.getDealerships.dealerships]);
      app.setDealerships({
        dealerships: data?.getDealerships?.dealerships,
      });
    }
  }, [data]);

  useEffect(() => {
    app.setFetchData({
      a_rowsPerPage: rowsPerPage,
      a_pageCount: page,
    });
  }, []);

  const getCurrentMonthPayload = (subscriptions) => {
    const currentDate = new Date(filterData?.monthYear);

    let getMonth = currentDate?.toLocaleString("default", { month: "long" });
    console.log("currentDate", getMonth);
    const currentMonthSubscriptions = subscriptions.filter((sub) => {
      const subscriptionDate = new Date(sub.date);
      console.log("subscriptionDate", subscriptionDate);
      return (
        subscriptionDate.getMonth() === currentDate.getMonth() &&
        subscriptionDate.getFullYear() === currentDate.getFullYear()
      );
    });
    let totalCount = currentMonthSubscriptions[0]?.totalCount;
    let totalRequest = currentMonthSubscriptions[0]?.totalRequestCount;
    console.log("totalRequest", currentMonthSubscriptions);
    return { totalCount, getMonth, totalRequest };
  };
  const { refetch: refetchBilling } = useQuery(DEALERSHIP_BILLING);

  const downloadHandler = (sample) => {
    refetchBilling({
      billingInput: {
        dealership_id: sample?.dealership_id,
      },
    }).then(({ data }) => {
      //monthYear

      // "2023-10-07"

      let getBill = data.dealershipBilling.billing;
      console.log("getbill", getBill);
      let thisMonthTotalCount = getCurrentMonthPayload(getBill);
      console.log("thisMonthmmmm", thisMonthTotalCount);
      console.log("getmonnnn", thisMonthTotalCount?.getMonth);
      let totalCost =
        sample?.subscriptions[0]?.cost +
        (thisMonthTotalCount?.totalCount > sample?.subscriptions[0]?.limit
          ? thisMonthTotalCount?.totalCount - sample?.subscriptions[0]?.limit
          : 0) *
          sample?.subscriptions[0]?.overage_cost;
      const texts = [
        [sample.full_name || "N/A", "", "Month", filterData.monthYear],

        [
          sample?.city
            ? sample?.number +
              " " +
              sample?.street +
              " " +
              sample?.city +
              " " +
              sample?.state +
              " " +
              sample?.zipcode
            : "N/A",
        ],
        [],
        [
          "Subscription ",
          "Max pull",
          "Total pulls",
          "Overage cost",
          "Payload",
          "Total Cost",
          "Request Quote Count",
        ],
        [
          sample?.subscriptions[0]?.cost || "N/A",
          sample?.subscriptions[0]?.limit || "N/A",
          thisMonthTotalCount?.totalCount || 0,

          sample?.subscriptions[0]?.overage_cost || "N/A",
          sample?.subscriptions
            ? sample.subscriptions[0].payload === 2
              ? "Data & Docs"
              : sample.subscriptions[0].payload === 1
              ? "Data"
              : "N/A"
            : "N/A",
          totalCost || 0,
          thisMonthTotalCount?.totalRequest,
        ],
      ];

      const worksheet = utils.aoa_to_sheet(texts);
      const workbook = utils.book_new();
      utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const excelBuffer = write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const file = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const element = document.createElement("a");
      element.href = URL.createObjectURL(file);
      element.download =
        sample.full_name +
        "-" +
        thisMonthTotalCount?.getMonth +
        // new Date().toLocaleString("en-US", {
        //   month: "long",
        // }) +
        " " +
        new Date().getFullYear() +
        ".xlsx";
      document.body.appendChild(element);
      element.click();
    });
  };
  const sortedDealerships = dealerships.slice().sort((a, b) => {
    return a.full_name.localeCompare(b.full_name);
  });
  console.log("ddd", sortedDealerships);
  return (
    <>
      <Box sx={DealershipStyles.dealerBox}>
        <BreadcrumbsComponent {...breadcrumb} />
        <Button
          variant="text"
          sx={DealershipStyles.dealerButton}
          startIcon={<PersonAddAlt1 />}
          onClick={() => {
            navigate(`/createDealership/dealership`);
          }}
        >
          Add Dealership
        </Button>
      </Box>

      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          margin: "2px 15px 3px 3px",
          boxShadow:
            "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
          borderRadius: "14px",
          maxHeight:
            window.innerHeight >= 1440
              ? "100vh"
              : window.innerHeight >= 1050
              ? "85vh"
              : window.innerHeight >= 900
              ? "80vh"
              : "100vh",
          height:
            window.innerHeight >= 1440
              ? "100vh"
              : window.innerHeight >= 1050
              ? "85vh"
              : window.innerHeight >= 900
              ? "80vh"
              : "80vh",
          overflow: "hidden",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <Box>
          <Box
            component="form"
            noValidate
            autoComplete="off"
            sx={DealershipStyles.noValidate}
          >
            <FormControl
              sx={DealershipStyles.filter}
              variant="outlined"
              size="small"
            >
              <InputLabel>Search Address</InputLabel>
              <OutlinedInput
                label="Search Address"
                value={filterData.dealershipCity}
                type="text"
                onChange={(event) => {
                  setFilterData({
                    ...filterData,
                    dealershipCity: event.target.value,
                  });
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton onClick={() => {}} edge="end"></IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <FormControl
              sx={DealershipStyles.filter}
              variant="outlined"
              size="small"
            >
              <InputLabel>
                Search Dealership Name / Email / Dealership Code
              </InputLabel>
              <OutlinedInput
                label="Search Dealership Name / Email / Dealership Code"
                value={filterData.dealershipName}
                type="text"
                onChange={(event) => {
                  setFilterData({
                    ...filterData,
                    dealershipName: event.target.value,
                  });
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton onClick={() => {}} edge="end"></IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                views={["month", "year"]}
                label="Month & Year"
                value={filterData.monthYear}
                // inputFormat="yyyy-MM-dd"
                maxDate={new Date()}
                onChange={(event) => {
                  console.log("eventt", event);
                  console.log("eventtfff", event.toISOString().slice(0, 10));
                  setFilterData({
                    ...filterData,
                    monthYear: event.toISOString().slice(0, 10),
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    sx={DealershipStyles.filter}
                    {...params}
                  />
                )}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton edge="end">
                      <EventIcon />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </LocalizationProvider>
            <FormControl>
              <IconButton
                onClick={() => {
                  setDealerships([]);
                  refetch();
                  setFilterData(INITIAL_FILTER);
                }}
                edge="start"
              >
                {<Refresh />}
              </IconButton>
            </FormControl>
          </Box>
          <TableContainer
            sx={{
              maxHeight:
                window.innerHeight >= 1440
                  ? "82vh"
                  : window.innerHeight >= 1050
                  ? "78vh"
                  : window.innerHeight >= 900
                  ? "67vh"
                  : "63vh",
              height:
                window.innerHeight >= 1440
                  ? "82vh"
                  : window.innerHeight >= 1050
                  ? "78vh"
                  : window.innerHeight >= 900
                  ? "67vh"
                  : "63vh",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell width={"10%"} sx={DealershipStyles.tableCell}>
                    Dealership Code
                  </TableCell>
                  <TableCell width={"20%"} sx={DealershipStyles.tableCell}>
                    Dealership
                  </TableCell>
                  <TableCell width={"20%"} sx={DealershipStyles.tableCell}>
                    Address
                  </TableCell>
                  <TableCell width={"10%"} sx={DealershipStyles.tableCell}>
                    Main Contact
                  </TableCell>
                  <TableCell width={"10%"} sx={DealershipStyles.tableCell}>
                    Email
                  </TableCell>
                  <TableCell width={"10%"} sx={DealershipStyles.tableCell}>
                    Phone
                  </TableCell>
                  <TableCell width={"5%"} sx={DealershipStyles.tableCell}>
                    # Standard Pulls
                  </TableCell>
                  <TableCell width={"5%"} sx={DealershipStyles.tableCell}>
                    Per pull Overage
                  </TableCell>
                  <TableCell width={"5%"} sx={DealershipStyles.tableCell}>
                    Subscription Cost
                  </TableCell>
                  <TableCell width={"8%"} sx={DealershipStyles.tableCell}>
                    Payload
                  </TableCell>
                  <TableCell
                    width={"5%"}
                    sx={DealershipStyles.tableCell}
                  ></TableCell>
                  <TableCell
                    width={"5%"}
                    sx={DealershipStyles.tableCell}
                  ></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {loading || dealerships.length <= 0 ? (
                  <TableRow>
                    <TableCell
                      sx={{
                        border: "none",
                        padding: "0px 16px 0px 16px",
                        textAlign: "center",
                      }}
                      colSpan={11}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          width: "100%",
                          margin: "16px",
                        }}
                      >
                        <h2>Dealerships loading..</h2>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  sortedDealerships.map((sample) => {
                    return (
                      <TableRow>
                        <TableCell
                          align="center"
                          sx={DealershipStyles.detailTableCell}
                        >
                          {sample?.dealership_code}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={DealershipStyles.tableRow}
                          onClick={() => {
                            navigate(`dealerships/${sample.dealership_id}`);
                          }}
                        >
                          {capitalizeFirstLetter(sample.full_name)}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={DealershipStyles.detailTableCell}
                        >
                          {sample?.city
                            ? sample?.number +
                              " " +
                              sample?.street +
                              " " +
                              sample?.city +
                              " " +
                              getStateCode(sample?.state, states) +
                              " " +
                              sample?.zipcode
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={DealershipStyles.detailTableCell}
                        >
                          {sample?.main_contact?.last_name === null ||
                          sample?.main_contact?.last_name === ""
                            ? "N/A"
                            : sample?.main_contact?.last_name}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={DealershipStyles.detailTableCell}
                          width={"10%"}
                        >
                          {sample.email || "N/A"}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={DealershipStyles.detailTableCell}
                          width={"10%"}
                        >
                          {sample?.phone_number
                            ? InputValidation.phoneNumberFormat(
                                sample.phone_number
                              )
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={DealershipStyles.detailTableCell}
                        >
                          {sample?.subscriptions[0]?.limit ||
                          sample?.subscriptions[0]?.limit === 0
                            ? sample.subscriptions[0].limit
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ padding: "0px,16px", border: "none" }}
                        >
                          {sample?.subscriptions[0]?.overage_cost ||
                          sample?.subscriptions[0]?.overage_cost === 0
                            ? sample.subscriptions[0].overage_cost
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={DealershipStyles.detailTableCell}
                        >
                          {sample?.subscriptions[0]?.cost ||
                          sample?.subscriptions[0]?.cost === 0
                            ? "$ " + sample.subscriptions[0].cost
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={DealershipStyles.detailTableCell}
                        >
                          {sample?.subscriptions
                            ? sample.subscriptions[0].payload === 2
                              ? "Data & Docs"
                              : sample.subscriptions[0].payload === 1
                              ? "Data"
                              : "N/A"
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={DealershipStyles.detailTableCell}
                        >
                          <SaveAltIcon
                            color="primary"
                            cursor="pointer"
                            onClick={() => downloadHandler(sample)}
                          />
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={DealershipStyles.detailTableCell}
                        >
                          <EmailOutlinedIcon
                            color="primary"
                            cursor="pointer"
                            onClick={() => {
                              dialog({
                                open: true,
                                bodyType: TYPE.EMAIL_BILLING,
                                maxWidth: "md",
                                body: <EmailBillingDialog data={sample} />,
                              });
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        {/* <TablePagination
          rowsPerPageOptions={[10, 20]}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(event, newPage) => {
            setPage(newPage);
          }}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
        /> */}
      </Paper>
    </>
  );
};

export default HocPopup(DealershipComponent);
